/** Аккаунт истории: по id или нику из адреса/памяти, иначе первый в списке. */
export function pickHistoryAccount(
  accounts: { account_id: string; username: string }[],
  wanted: string,
): string {
  if (accounts.length === 0) return '';
  const w = wanted.replace(/^@/, '').toLowerCase();
  const found = w ? accounts.find((a) => a.account_id === wanted || a.username.toLowerCase() === w) : undefined;
  return (found ?? accounts[0]).account_id;
}
